import React from "react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import { opgaverData } from "../data/siteData";
import { useContactDrawer } from "../context/ContactDrawerContext";

export default function OpgaverOverview() {
  const { openDrawer } = useContactDrawer();

  return (
    <div className="pt-[72px] bg-brand-sand-50 min-h-screen">
      <SEO
        title="Opgaver | Elmegaarden Have og Anlæg"
        description="Tekst er på vej."
        canonical="/opgaver"
      />

      {/* Header Banner */}
      <section className="bg-brand-green-950 text-white pt-24 pb-16">
        <div className="max-w-7xl mx-auto px-6">
          <div className="max-w-3xl text-left">
            <h1 className="font-display text-4xl md:text-5xl font-bold text-white mb-4">
              Opgaver
            </h1>
            <p className="text-neutral-300 text-base md:text-lg leading-relaxed">
              Din professionelle anlægsgartner til belægningsopgaver, lægning af indkørsel og terrasse, samt opsætning af støttemure og vedligeholdelse af grønne områder.
            </p>
          </div>
        </div>
      </section>

      {/* Opgaver List */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {opgaverData.map((opgave) => (
              <div
                key={opgave.slug}
                className="bg-white border border-brand-sand-200/80 rounded-sm overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between text-left"
              >
                {opgave.galleryImages && opgave.galleryImages.length > 0 && (
                  <div className="aspect-16/10 overflow-hidden bg-neutral-100">
                    <img
                      src={opgave.galleryImages[0].src.replace(
                        "https://assets.auxodev.dk/assets/",
                        "https://assets.auxodev.dk/cdn-cgi/image/width=600,height=375,fit=cover,quality=80,format=auto/assets/"
                      )}
                      alt={opgave.galleryImages[0].alt || opgave.heading}
                      className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                      loading="lazy"
                    />
                  </div>
                )}
                <div className="p-6 md:p-8 flex flex-col gap-4 flex-grow justify-between">
                  <div className="flex flex-col gap-3">
                    <h2 className="font-display text-xl font-bold text-brand-green-900">
                      {opgave.heading}
                    </h2>
                    <p className="text-sm text-brand-charcoal/70 line-clamp-3 leading-relaxed">
                      {opgave.metaDescription}
                    </p>
                  </div>
                  <div className="pt-4 border-t border-brand-sand-100 flex items-center justify-between">
                    <Link
                      to={`/opgaver/${opgave.slug}`}
                      className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-green-700 hover:text-brand-green-900 transition-colors"
                    >
                      Læs mere <i className="fa-solid fa-arrow-right text-[10px]" />
                    </Link>
                  </div>
                </div>
              </div>
            ))}

            {/* Andre Opgaver Card */}
            <div className="bg-white border border-brand-sand-200/80 rounded-sm overflow-hidden shadow-sm hover:shadow-md transition-all duration-300 flex flex-col justify-between text-left">
              <div className="aspect-16/10 overflow-hidden bg-neutral-100">
                <img
                  src="https://assets.auxodev.dk/cdn-cgi/image/width=600,height=375,fit=cover,quality=80,format=auto/assets/77df7d82-25aa-453c-8f7b-e2453151bb33/645a442217253_ae6bb7e0.jpeg"
                  alt="Andre opgaver"
                  className="w-full h-full object-cover transition-transform duration-500 hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="p-6 md:p-8 flex flex-col gap-4 flex-grow justify-between">
                <div className="flex flex-col gap-3">
                  <h2 className="font-display text-xl font-bold text-brand-green-900">
                    Andre opgaver
                  </h2>
                  <p className="text-sm text-brand-charcoal/70 line-clamp-3 leading-relaxed">
                    Vi kan lave alt inden for have og anlæg. Du er velkommen til at ringe til os og få et tilbud.
                  </p>
                </div>
                <div className="pt-4 border-t border-brand-sand-100 flex items-center justify-between">
                  <Link
                    to="/andre-opgaver"
                    className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-brand-green-700 hover:text-brand-green-900 transition-colors"
                  >
                    Læs mere <i className="fa-solid fa-arrow-right text-[10px]" />
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom CTA Box */}
          <div className="mt-16 bg-brand-green-900 text-white p-8 md:p-12 rounded-sm text-center flex flex-col items-center gap-6 shadow-md">
            <h2 className="font-display text-2xl md:text-3xl font-bold">
              Har du en opgave, der ikke er nævnt her?
            </h2>
            <p className="text-sm md:text-base text-neutral-200 max-w-2xl leading-relaxed">
              Vi løser en lang række specialopgaver for både private, erhverv og boligforeninger. Kontakt os for en uforpligtende samtale og besigtigelse.
            </p>
            <button
              onClick={openDrawer}
              className="px-8 py-3.5 bg-[#7ca632] hover:bg-[#6b9128] text-white font-bold text-xs md:text-sm tracking-wide rounded-sm transition-all duration-300 shadow-sm cursor-pointer"
            >
              Få et uforpligtende tilbud
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}
